import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    designVersion
  } = _ref;
  var cornerRadius = designContext.get('offer-breakdown/corner-radius').pixelValue;
  var borderRadius = isLollipop(designVersion) ? 0 : cornerRadius;
  return {
    containerStyle: {
      backgroundColor: designContext.get('colors/backgrounds/subtle-floating').toString(),
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 15,
      paddingRight: 15,
      borderRadius
    },
    itemContainerStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    itemTextStyle: _objectSpread(_objectSpread({
      color: designContext.get('colors/text/default').toString()
    }, designContext.get('text-style/text/labels/body/regular').styles()), {}, {
      lineHeight: 20
    }),
    detailTextStyle: isStrong => _objectSpread(_objectSpread({
      color: designContext.get('colors/text/default').toString()
    }, isStrong ? designContext.get('text-style/text/labels/body/medium').styles() : designContext.get('text-style/text/labels/body/regular').styles()), {}, {
      lineHeight: 20
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map